import { RouteConfig } from 'vue-router'
import Main from '../Line/Main.vue'

export const lineRoutes: RouteConfig = {
  path: '/line',
  name: 'line',
  component: Main
}
